import React, { useContext } from 'react';
import { Row, Text, TextInput } from 'library/ui';

import { BannedWorkerModalContext } from './BannedWorkerModalContext';

export default function Memo({
    dirty,
    memo,
    setMemo,
    locationId,
}: {
    dirty: boolean;
    memo: string | null;
    setMemo: (id: number, memo: string) => void;
    locationId?: number;
}) {
    const { isAdmin } = useContext(BannedWorkerModalContext);

    if (!isAdmin) return null;

    return dirty ? (
        <TextInput
            placeholder="Memo/Notes"
            fullWidth
            onChange={(value) => (locationId ? setMemo(locationId, value) : setMemo(0, value))}
            value={memo ?? ''}
        />
    ) : (
        <Row gap="sm">
            <Text size="sm" weight="semibold">
                Memo:
            </Text>
            <Text size="sm">{memo ?? 'N/A'}</Text>
        </Row>
    );
}
